import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {CommonService} from 'src/app/shared/utils/common.service';
import {UtilsService} from 'src/app/shared/utils/utils.service';
import {moduloVMI} from '../../diccionarios/moduloVMI';
import {NucleoModel} from '../../models/vmi-nucleoModel';

@Injectable({
  providedIn: 'root'
})
export class VmiEstadoProductoService {

  diccionarioUrl: any = {};
  url: string;

  constructor(
    private _commom: CommonService,
    private _utils: UtilsService
  ) {
    this.url = this._utils.getVmi();
    this.diccionarioUrl = moduloVMI.url.informes;
  }

  getAllEstadoProucto(): Observable<NucleoModel[]> {
    return this._commom.peticionGetConHeader(this.url + this.diccionarioUrl.estadoProductoGetAll);
  }

  getAllEstadoProuctoCustom(): Observable<NucleoModel[]> {
    return this._commom.peticionGetConHeader(this.url + this.diccionarioUrl.estadoProductoGetAll+'-custom');
  }

  getEstadoProuctoByCliente(innIdcliente: string): Observable<NucleoModel[]> {
    return this._commom.peticionGetConHeader(this.url + this.diccionarioUrl.estadoProducto + `/${innIdcliente}`);
  }

}
